import React from 'react'

import { Stamp, Tooltip } from './style'

const dataTestLabel = 'seal_cardelivery'
const StampCarDelivery = ({ daInfo = false }) => (
  <Stamp daInfo={daInfo} data-test-component={dataTestLabel}>
    <Tooltip>Car Delivery</Tooltip>
  </Stamp>
)

export default StampCarDelivery
